$(function() {
    $('[data-fancybox]').fancybox({});
});
